"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var material_1 = require("@mui/material");
var mountIsland_1 = require("../mountIsland");
var Lang_js_1 = require("../Lang.js");
var SeedcardSend = function () {
    var _a = (0, react_1.useState)(false), isSeedcardSending = _a[0], setSeedcardSending = _a[1];
    var _b = (0, react_1.useState)(false), seedcardSent = _b[0], setSeedcardSent = _b[1];
    var _c = (0, react_1.useState)(false), seedcardError = _c[0], setSeedcardError = _c[1];
    var seedcardUniqueId = document.getElementById('seedcard-send').getAttribute('data-seedcard-unique-id');
    if (!isSeedcardSending) {
        setSeedcardSending(true);
        axios_1.default.get('/api/seedcard/send?seedcard_unique_id=' + seedcardUniqueId)
            .then(function (response) {
            if (response.data.success) {
                setSeedcardSent(true);
            }
            else {
                console.error('Error sending seedcard:', response.data.message);
                setSeedcardError(true);
            }
        })
            .catch(function (error) {
            console.error('Error sending seedcard:', error);
            setSeedcardError(true);
        });
    }
    return (react_1.default.createElement(material_1.Box, null,
        !seedcardSent && !seedcardError && (react_1.default.createElement(material_1.Box, { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" },
            react_1.default.createElement(material_1.CircularProgress, null),
            react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h6", sx: { mt: 2 } }, (0, Lang_js_1.__)('Sending seedcard...')))),
        seedcardSent && (react_1.default.createElement(material_1.Alert, { severity: "success", sx: { mb: 4 } }, (0, Lang_js_1.__)('Seedcard sent successfully!'))),
        seedcardError && (react_1.default.createElement(material_1.Alert, { severity: "error", sx: { mb: 4 } }, [
            (0, Lang_js_1.__)('Error sending seeding card, please contact '),
            react_1.default.createElement(material_1.Box, { key: "email", component: "a", href: "mailto:webteam@msia.org" }, "webteam@msia.org"),
        ]))));
};
var seedcardSendContainer = document.getElementById('seedcard-send');
if (seedcardSendContainer) {
    (0, mountIsland_1.mountIsland)(seedcardSendContainer, react_1.default.createElement(SeedcardSend, null));
}
